<template>
  <span
    class="ellipsis-hover-tooltip"
    :class="[{ 'ellipsis-hover-tooltip--truncated': truncated }, rootClass]"
    @mouseenter="checkTruncation"
  >
    <span ref="label" class="ellipsis-hover-tooltip__label" :class="labelClass">
      <slot>{{ text }}</slot>
    </span>
    <span v-if="truncated" class="portal-hover-tooltip" role="tooltip">
      <slot name="tooltip">{{ tooltipText || text }}</slot>
    </span>
  </span>
</template>

<script>
export default {
  name: 'EllipsisHoverTooltip',
  props: {
    text: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    },
    labelClass: {
      type: [String, Array, Object],
      default: ''
    },
    rootClass: {
      type: [String, Array, Object],
      default: ''
    }
  },
  data() {
    return {
      truncated: false
    };
  },
  methods: {
    checkTruncation() {
      const el = this.$refs.label;
      if (!el) return;
      this.truncated = el.scrollWidth > el.clientWidth;
    }
  }
};
</script>

<style scoped lang="scss">
@import '../styles/portal-tooltip';

.ellipsis-hover-tooltip {
  position: relative;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;

  &__label {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
  }

  &--truncated {
    @include portal-hover-tooltip-trigger('portal-hover-tooltip', left);
    @include portal-hover-tooltip-bubble('portal-hover-tooltip', left);
  }
}
</style>
